export default "__VITE_ASSET__a3baa08e__"